import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../store';
import {AppEffects} from '../../store/app';
import {useLocation} from 'react-router';
import Routing from 'routes';
import Masthead from "../masthead";
import AppSpinner from "../spinner/spinner";
import {AuthActions} from "../../store/auth";

const InitWrapper = () => {

  const isLoading = useSelector((state:RootState) => state.app.isLoading);
  const initComplete = useSelector((state:RootState) => state.app.initComplete);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(AppEffects.init());
  }, [dispatch]);

  useEffect(() => {
    dispatch(AuthActions.clearError(0));
  }, [location, dispatch]);

  return (
    <div role="main">
      { initComplete &&
      <>
        <Masthead/>
        {isLoading ? <AppSpinner/> : <Routing/>}
      </>
      }
    </div>
  )
};

export default InitWrapper;
